module.exports = __webpack_public_path__ + "img/fd_open.49482b48.png";